import React from 'react';
import ContentLoader from 'react-content-loader';

const ReleasePlanModelLoader = () => (
    <div className="card-list">
        <div>
            <ContentLoader
                height={537}
                width={195}
                speed={1}
                primarycolor="#f3f3f3"
                secondarycolor="#ecebeb">
                <rect x="5" y="5" width="185" height="8"/>

                <rect x="5" y="5" width="185" height="5"/>
                <rect x="5" y="15" width="185" height="5"/>
                <rect x="5" y="25" width="185" height="5"/>
                <rect x="5" y="35" width="185" height="5"/>
                <rect x="5" y="45" width="185" height="5"/>
                <rect x="5" y="55" width="185" height="5"/>
                <rect x="5" y="65" width="185" height="5"/>
                <rect x="5" y="75" width="185" height="5"/>
                <rect x="5" y="85" width="185" height="5"/>
                <rect x="5" y="95" width="185" height="5"/>
                <rect x="5" y="105" width="185" height="5"/>
                <rect x="5" y="115" width="185" height="5"/>
                <rect x="5" y="125" width="185" height="5"/>
                <rect x="5" y="135" width="185" height="5"/>
                <rect x="5" y="145" width="185" height="5"/>
                <rect x="5" y="155" width="185" height="5"/>
                <rect x="5" y="165" width="185" height="5"/>
                <rect x="5" y="175" width="185" height="5"/>
                <rect x="5" y="185" width="185" height="5"/>
                <rect x="5" y="195" width="185" height="5"/>
                <rect x="5" y="205" width="185" height="5"/>
                <rect x="5" y="215" width="185" height="5"/>
                <rect x="5" y="225" width="185" height="5"/>
                <rect x="5" y="235" width="185" height="5"/>
                <rect x="5" y="245" width="185" height="5"/>
                <rect x="5" y="255" width="185" height="5"/>
                <rect x="5" y="265" width="185" height="5"/>
                <rect x="5" y="275" width="185" height="5"/>
            </ContentLoader>
        </div>
    </div>
);

export default ReleasePlanModelLoader;
